import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./tc.module.css";

const TcPage = () => {
  return (
    <Container className={styles.tcPage}>
      <Row>
        <Col md={12}>
          <h2><strong>Terms and Conditions of Use</strong></h2><br/>
          <h6><strong>
            PLEASE READ AND REVIEW THE FOLLOWING TERMS AND CONDITIONS OF USE
            CAREFULLY BEFORE USING THIS WEBSITE
          </strong></h6>
          <p>
            KUR International, LLC (“KUR”), and its subsidiaries and affiliates
            maintain this Kurr.com web site (this “Web Site”) and related
            websites that refer to these Terms and Conditions of Use (“Terms of
            Use”) as a service to its customers and prospective customers. These
            Terms of Use constitute an agreement between you and KUR and are
            sometimes referred to herein as “this Agreement”. The terms “we”,
            “us”, and “our” refer to KUR, and the terms “you” or “yours” refers
            to you, as user of this Web Site. If you do not wish to be bound by
            these Terms of Use, you should not access or use this Web Site and
            you must terminate your use immediately.
          </p>
          <p>
            Proceeding to use this Web Site indicates your acknowledgment you
            have read and accepted these Terms of Use. You also represent that
            you are at least 18 years of age and possess the legal capacity to
            enter into this Agreement. You may print a copy of these Terms of
            Use for your records at any time by using the “print” function on
            your Internet browser
          </p>
          <section>
            <h4><strong><u>Copyrights, Trademarks, and IP Rights Generally</u></strong></h4>
            <p>
              KUR enforces its intellectual property rights to the fullest
              extent allowed by law. The entire contents of this Web Site are
              copyrighted under United States’ copyright laws by KUR. No part of
              this Web Site may be reproduced, stored in a retrieval system,
              transmitted or retransmitted in any form or by any means,
              electronic, mechanical, photocopying, recording or otherwise,
              without the prior written permission of KUR. You may print and
              download portions of material from the different areas of this Web
              Site solely for your own informational, non-commercial, individual
              and internal reference, provided that you reproduce the copyright
              notice which appears at the end of these Terms of Use. Any
              content, software and other material downloaded from this Web Site
              (“Content”) are the property of KUR or its licensors and is
              protected by United States and international copyright and
              intellectual property laws and treaty provisions. All rights to
              patents, copyrights, trademarks, service marks, trade secrets, and
              other intangible property rights in the Content or any
              modifications to it shall remain in KUR and its licensors. To the
              extent any Content consists of software, you may not modify,
              reverse engineer, decompile, disassemble, or create derivative
              works based on the Content, or remove any proprietary notices or
              labels that it contains. Subject to the foregoing, you may make:
              (a) one machine-readable copy, (b) one backup copy, and (c) one
              print copy of any portions of material downloaded from different
              areas of this Web Site solely for your own informational,
              non-commercial, individual reference, provided that you reproduce
              the copyright notice which appears at the end of these Terms of
              Use. Any other copying, distribution or publication is strictly
              prohibited without the express prior written consent of KUR. Any
              unauthorized use terminates any permission or license granted by
              KUR.
            </p>
            <p>
              KUR service and product names are trademarks and/or service marks
              of KUR, its affiliates and/or its subsidiaries. These and all
              other names, logos and marks on this Web Site are owned or
              licensed by KUR and may not be used by you without express prior
              written permission from KUR
            </p>
          </section>
          <section>
            <h4><strong><u>Digital Millennium Copyright Act</u></strong></h4>
            <p>
              The Digital Millennium Copyright Act of 1998 (the “DMCA”) provides
              recourse for copyright owners who believe that material appearing
              on the Internet infringes their rights under U.S. copyright law.
              If you believe that your work has been copied and posted on this
              Web Site in a way that constitutes copyright infringement, please
              provide us with the following information: (1) an electronic or
              physical signature of the copyright owner or of the person
              authorized to act on behalf of the owner of the copyright
              interest; (2) a description of the copyrighted work that you claim
              has been infringed; (3) a description of where the material that
              you claim is infringing is located on this Web Site; (4) your
              address, telephone number, and e-mail address; (5) a written
              statement by you that you have a good faith belief that the
              disputed use is not authorized by the copyright owner, its agent,
              or the law; and (6) a statement by you, made under penalty of
              perjury, that the information in subsections (1) – (5) above in
              your notice is accurate and that you are the copyright owner or
              authorized to act on the copyright owner’s behalf. Any
              notification by a copyright owner or a person authorized to act on
              its/their behalf that fails to comply with requirements of the
              DMCA shall not be considered sufficient notice and shall not be
              deemed to confer upon KUR actual knowledge of facts or
              circumstances from which infringing material or acts are evident.
              Claims of copyright infringement can be sent to the following
              address:
            </p>
            <p>
              KUR Corporation
              <br />
              2425 Cedar Springs Road
              <br />
              Dallas, Texas 75201
              <br />
              Attn: VP of Legal
            </p>
            <p>
              We suggest that you consult legal counsel before filing a
              copyright infringement notice. You should note that there can be
              penalties for false claims under the DMCA.
            </p>
          </section>
          <section>
            <h4><strong><u>Privacy Statement</u></strong></h4>
            <p>
              KUR has a privacy policy (“Privacy Policy”) that sets forth the
              privacy policies and practices of KUR as they relate to the
              collection, use, processing and disclosure of information in
              connection with your use of this Web Site. The Privacy Policy is
              incorporated into these Terms of Use by reference, as if set forth
              fully herein. Any changes to the Privacy Policy will be
              automatically incorporated into the Terms of Use, effective upon
              posting of such changes.
            </p>
          </section>
          <section>
            <h4><strong><u>User-Provided Information and User-Generated Content</u></strong></h4>
            <p>
              Any questions, comments, feedback, suggestions, ideas, or the like
              (collectively, “Feedback”) you provide through this Website is
              without obligation of any kind, and KUR will be free to reproduce,
              use, disclose and distribute such Feedback to others without
              limitation. You agree to grant to KUR a non-exclusive,
              royalty-free, worldwide, perpetual license, with the right to use,
              sublicense, reproduce, distribute, create derivative works of,
              publicly display and publicly perform any Feedback, including any
              materials and other information (including, without limitation,
              ideas for new or improved products and services) you submit to KUR
              through this Web Site (including through e-mail, bulletin boards,
              forums or news groups) by any means and in any medium. To the
              extent permitted under the Privacy Policy, You also grant to KUR
              the right to use your name in connection with the submitted
              materials and other information as well as in connection with all
              advertising and promotional material related to it. You agree that
              you will have no recourse against KUR for any infringement or
              misappropriation of any proprietary right in your Feedback and
              communications to us.
            </p>
            <p>
              You understand and agree that e-mail submissions may not be secure
              and are subject to the risk of interception by third parties. You
              agree not to submit or transmit any communication or materials
              through this Web Site that (i) is defamatory, threatening, obscene
              or harassing, (ii) violates the legal rights of others or breach
              any legal duty owed to others, (iii) contains a virus, worm,
              Trojan horse or any other harmful component, (iv) incorporates
              copyrighted or other confidential or proprietary material of any
              third party without that party’s permission or (iv) otherwise
              violates any applicable laws or regulations. KUR shall not be
              subject to any obligations of confidentiality regarding any
              information or materials that you submit online except as (x)
              specified in these Terms of Use, (y) set forth in the Privacy
              Policy, or (z) set forth in any additional terms and conditions
              relating to specific products or services, or as otherwise
              specifically agreed in writing by KUR or required by law or
              regulation.
            </p>
          </section>
          {/* <section>
            <h4><strong><u>Text Messaging</u></strong></h4>
            <p>
              You may receive text messages related to KUR services. This
              includes referral notifications for SmartBeat screenings and
              appointment reminders, resulting in approximately 1–3 text messages
              per patient per episode of care. KUR Research LLC also utilizes
              text messaging for study-related communications. Message and data
              rates may apply.
            </p>
            <p>
              At any time, you may text "STOP" to unsubscribe or text "HELP" for
              assistance.
            </p>
          </section> */}
          <section>
            <h4><strong><u>Inclusion of Other Notices and Terms</u></strong></h4>
            <p>
              This Web Site may contain other notices, terms and conditions, and
              copyright information, the terms of all of which must be observed
              and followed. Information provided on this Web Site does not
              constitute an offer to sell any particular product or service or
              engage in any other commercial transaction until KUR accepts your
              order or the parties enter into a mutual agreement. You may have
              other agreements with KUR. Those agreements are separate and in
              addition to these Terms of Use. These Terms of Use do not modify,
              revise, or amend the terms of any other agreements you may have
              with KUR.
            </p>
          </section>

          <section>
            <h4><strong><u>Links to Third-Party Websites</u></strong></h4>
            <p>
              Links in this Web Site may allow you to leave KUR’s Web Site or be
              sent to another third-party’s website. KUR is providing these
              links to you only as a convenience, and the inclusion of any link
              neither implies endorsement by KUR of the linked site nor
              obligates you to click the link. Third-party linked sites are not
              under the control of KUR and KUR is not responsible for the
              contents of any linked site or any link contained in a linked
              site, or any changes or updates to such sites. You are responsible
              for taking precautions to ensure that whatever you select for your
              use is free of such items as infection viruses, worms, Trojan
              horses or other code that manifests contaminating or destructive
              properties, and other items of a harmful or destructive nature. It
              is also your responsibility to review the privacy statements on
              any linked sites, as their privacy rules and standards may be
              different than KUR’s and KUR is not responsible for their privacy
              statements or practices. You should also review the terms and
              conditions of any linked sites. KUR welcomes bookmarks and links
              to its Web Site for lawful purposes. You are free to establish a
              hypertext link to this Web Site as long as the link does not state
              or imply any sponsorship or endorsement of your site by KUR or any
              of its affiliates. KUR reserves the right, in its sole discretion
              at any time, to deny any request, or rescind any permission
              granted, to link to this Web Site and to require termination of
              any such link to this Web Site. You may not frame any content of
              this Web Site or utilize any framing techniques in any way,
              including but not limited to enclosing any trademark, logo, or
              other proprietary information (including, but not limited to,
              images, text, page layout, or form), without KUR’s prior written
              consent. You may also not incorporate any intellectual property
              contained on this Web Site or owned by KUR or its licensors. You
              may not use any meta tags or any other “hidden text” utilizing
              KUR’s name or trademarks without the express written consent of
              KUR
            </p>
            <p>
             IN NO EVENT WILL KUR, ITS AFFILIATES, SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, REPRESENTATIVES, OR ASSOCIATES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR ANY OTHER DAMAGES WHATSOEVER INCLUDING BUT NOT LIMITED TO, LOST PROFITS OR BUSINESS INTERRUPTION DAMAGES EVEN IF KUR OR ITS REPRESENTATIVES HAVE BEEN SPECIFICALLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, FOR ANY USE OF THE LINKED SITES AS SET FORTH IN THIS SECTION.
            </p>
          </section>
          <section>
            <h4><strong><u>Limits on Accuracy</u></strong></h4>
            <p>
              This Web Site is maintained as a service by KUR to provide
              information about its products and services. KUR makes reasonable
              efforts to make information contained on this Web Site accurate at
              the time it is created. However, information may become outdated
              over time. It is important that you rely on the advice of an
              appropriate professional when interpreting and using this
              information. Nothing contained on this Web Site is to be construed
              as medical, legal, investment, financial or other advice, or any
              instruction or guidance regarding any products supplied or
              distributed by KUR. KUR makes no warranties or representations as
              to the accuracy of any information on this Web Site. All users
              agree that all access to and use of this Web Site is at their own
              risk. Information on this Web Site may contain technical
              inaccuracies or typographical errors. Information may be changed
              or updated without notice. KUR may also make improvements and
              changes in the products and services described in this Web Site at
              any time without notice.
            </p>
          </section>
          <section>
            <h4><strong><u>No Unlawful or Prohibited Use</u></strong></h4>
            <p>
              As a condition of your use of this Web Site and Content, you agree
              not to use this Web Site or its Content for any purpose that is
              unlawful or prohibited by these terms, conditions, and notices.
              You agree not to use this Web Site or its Content in any manner
              that could damage, disable, overburden, or impair any KUR server,
              or the network(s) connected to any KUR server, or interfere with
              any other party’s use and enjoyment of this Web Site and its
              Content. You agree not to attempt to gain unauthorized access to
              this Web Site, other accounts, computer systems or networks
              connected to any KUR server or to this Web Site, through hacking,
              password mining or any other means. You also agree to not obtain
              or attempt to obtain any materials or information through any
              means not intentionally made available through this Web Site or
              its Content.
            </p>
          </section>
          <section>
            <h4><strong><u>Disclaimer and Limit on Damages</u></strong></h4>
            <p>
              You understand that KUR cannot and does not guarantee that Content
              available from or on this Web Site will be free of infection,
              viruses, or other code that manifest contaminating or destructive
              properties. You are responsible for implementing sufficient
              procedures and checkpoints to satisfy your particular requirements
              for accuracy of data input and output, and for maintaining a means
              external to this Web Site for the reconstruction of any lost data.
              You assume all responsibility and risk for your use of this Web
              Site, including your responsibility to evaluate the accuracy,
              completeness and usefulness of all material and reports provided
              through or generated by this Web Site. KUR does not warrant that
              this Web Site will be uninterrupted or error-free or that defects
              in this Web Site will be corrected. Content, including any
              software provided on this Web Site and related communications, are
              provided “as is” for information purposes only and KUR makes no
              guarantee or warranty with respect to correctness, reliability,
              accuracy or appropriateness of the material or the results
              obtained from the use of the services provided on this Web Site.
              You agree that use of this Web Site is at your own risk. In
              addition, all warranties, either express or implied, are hereby
              disclaimed, including warranties of performance, merchantability,
              fitness for a particular purpose (even if KUR or its authorized
              representatives have been advised of the possibility of any such
              purpose), or non-infringement. KUR has no obligation or duty to
              update any information on this Web Site.
            </p>
            <p>
            IN NO EVENT WILL KUR, ITS AFFILIATES, SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, REPRESENTATIVES OR ASSOCIATES, OR ANY PARTY INVOLVED IN CREATING, PRODUCING, HOSTING OR DISTRIBUTING THIS WEB SITE BE LIABLE TO YOU OR ANY PARTY FOR ANY DIRECT, INDIRECT, SPECIAL OR OTHER CONSEQUENTIAL DAMAGES, INCLUDING, WITHOUT LIMITATION, ANY LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR OTHER DATA ON YOUR INFORMATION HANDLING SYSTEM OR OTHERWISE, EVEN IF KUR OR ITS AUTHORIZED REPRESENTATIVES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, FOR ANY CLAIM ATTRIBUTABLE TO USE OF THIS WEB SITE, INCLUDING ANY DAMAGES DUE TO ERRORS, OMISSIONS, OR OTHER INACCURACIES IN THIS WEB SITE OR CONTENT OR OTHER MATERIAL DOWNLOADED THROUGH OR HYPER LINKED FROM THIS WEB SITE. IN ANY EVENT, THE TOTAL OF ALL DAMAGES, INCLUDING DIRECT DAMAGES (WHETHER GROUNDED IN CONTRACT, TORT OR OTHERWISE) ARISING UNDER OR RELATED TO THIS WEB SITE, OR THE RESULTS OBTAINED THEREFROM, WILL BE LIMITED TO THE AGGREGATE AMOUNT OF ALL SUMS PAID BY YOU TO KUR FOR SERVICES PROVIDED THROUGH THIS WEB SITE DURING THE ONE (1) MONTH PRIOR TO THE DATE ON WHICH SUCH DAMAGES WERE FIRST INCURRED, OR IF YOU DO NOT PAY FOR ANY SERVICES RENDERED TO YOU THROUGH THIS WEB SITE, $100. BECAUSE SOME STATES DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE MAY NOT APPLY TO YOU. IN SUCH STATES, KUR’S LIABILITY IS LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW.
            </p>
          </section>
          <section>
            <h4><strong><u>Product Warranty</u></strong></h4>
            <p>
              EXCEPT AS OTHERWISE PROVIDED IN AN EXECUTED AGREEMENT BETWEEN YOU AND KUR, KUR DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING THOSE OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR A PARTICULAR PURPOSE, FOR PRODUCTS AND SERVICES. No oral or written information provided by KUR, its employees or other representatives will create any such warranty.
            </p>
          </section>
          <section>
            <h4><strong><u>Indemnity</u></strong></h4>
            <p>
              You agree to indemnify, defend, and hold harmless KUR and its
              affiliates and their respective officers, directors, employees,
              agents, licensors, suppliers, and any third-party information
              providers to this Web Site from and against all losses, expenses,
              damages and costs, including reasonable attorneys’ fees, resulting
              from any information you provide or from any violation of this
              Agreement by you.
            </p>
          </section>
          <section>
            <h4><strong><u>Waiver and Release</u></strong></h4>
            <p>
              You hereby release and forever waive any and all claims you may
              have against KUR, its affiliates, subsidiaries, officers,
              directors, employees, agents, associates, representatives and
              suppliers for losses or damages you sustain in connection with
              your use of this Web Site. This waiver may not apply to gross
              negligence by KUR or any other claims that cannot be lawfully
              waived or limited.
            </p>
          </section>
          <section>
            <h4><strong><u>Term and Termination</u></strong></h4>
            <p>
              KUR may terminate your right to use this Web Site at any time,
              with or without cause. You are under no obligation to use or
              continue to use this Web Site. KUR may terminate, suspend or
              discontinue any functionality or feature of this Web Site at any
              time without notice. We will not be liable to you or any third
              party for any such termination. However, if you have an agreement
              with KUR that provides for the operation of such functionality,
              KUR will continue employing such functionality subject to the
              terms and conditions of that agreement.
            </p>
          </section>
          <section>
            <h4><strong><u>Applicable Law</u></strong></h4>
            <p>
              To the extent there is a conflict between any provision of this
              Agreement and any present law or regulation contrary to which the
              parties may not agree, such law or regulation will prevail;
              however, in such event, the affected provisions will be limited
              only to the extent necessary to bring them within the requirements
              of the law and to otherwise carry out the purposes of this
              Agreement. By accessing or using this Web Site, you agree it is
              intended to be accessed and used only within the United States and
              will be only construed according to United States law. Any access
              or use from other locations is subject to your compliance with all
              applicable local laws, and KUR will not be held responsible or
              liable for your use of this Web Site in such other locations. KUR
              makes no representation that material on this Web Site is
              appropriate outside the United States.
            </p>
          </section>
          <section>
            <h4><strong><u>General</u></strong></h4>
            <p>
              This Agreement will be governed and construed in accordance with
              the internal laws of the State of Texas, without regard to its
              conflicts of laws principles. You agree that any legal action or
              proceeding between KUR and you for any purpose concerning this
              Agreement or the parties’ obligations hereunder will be brought
              exclusively in a federal or state court of competent jurisdiction
              sitting in Dallas County, Texas. Any claim or cause of action you
              may have with respect to this Web Site must be commenced within
              one (1) year after the claim or cause of action arises or such
              claim or cause of action is barred. Any rights not expressly
              granted herein are reserved to KUR. KUR’s failure to insist upon
              or enforce strict performance of any provision of this Agreement
              will not be construed as a waiver of any provision or right.
              Neither the course of conduct between the parties nor trade
              practice will act to modify any provision of this Agreement. KUR
              may assign its rights and duties under this Agreement to any party
              at any time without notice to you. All provisions of this
              Agreement will be deemed to be severable. This Agreement and its
              related documents supersede all prior oral and written
              representations and agreements, which may have been entered into
              by the parties to this Agreement that relate to the subject matter
              of this Agreement.
            </p>
          </section>
          <section>
            <h4><strong><u>Updates and Modifications to Terms of Use</u></strong></h4>
            <p>
              These Terms of Use become effective on August 1, 2023. KUR may
              update and modify this Agreement at any time and from time to
              time, and such updates and modifications will be effective
              immediately upon posting the updated/modified Agreement. You agree
              to review this Agreement periodically to be aware of such updates
              and modifications and your continued access or use of this Web
              Site after any updates and modifications will be deemed your
              conclusive acceptance of the updated/modified Agreement.
            </p>
          </section>
          <p style={{ textAlign: "left", marginTop: "2rem" }}>
            © Copyright KUR International, LLC – August 2023
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default TcPage;
